<template>
    <div class="Map" id="map">

    </div>
</template>
<script>
import {ref, onMounted} from 'vue'
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import useMap from "../composables/useMap";

export default {
    name: "Map",
    components: {},

    setup(props) {
        const mapParams = useMap(props)
        // const map = ref(null)




        onMounted(() => {
            const map = L.map('map').setView(mapParams.map.center, mapParams.map.zoom);
            L.tileLayer(mapParams.map.tileLayer.url, {
                maxZoom: 19,
            }).addTo(map);

            const icon = L.icon({
                iconUrl: '/local/templates/main/img/icons/marker.svg',
                // shadowUrl: 'leaf-shadow.png',

                iconSize:     [38, 95], // size of the icon
                // shadowSize:   [50, 64], // size of the shadow
                iconAnchor:   [10, 10], // point of the icon which will correspond to marker's location
                // shadowAnchor: [4, 62],  // the same for the shadow
                popupAnchor:  [0, 0], // point from which the popup should open relative to the iconAnchor
            });

            const marker = L.marker(mapParams.map.center, {icon: icon}).addTo(map);

            marker.bindTooltip("г.Астана, ул.Достык, 18, офис 20.17").openTooltip();
        })
    }
};
</script>

<style scoped lang="scss">
.Map {
    height: 100%;
    width: 100%;
    min-height: rem(333);

    .leaflet-container {
        min-height: inherit;
    }
}
</style>